import styled, { css } from 'styled-components';
import { Pulse } from './Pulse';
export var SkeletonHeading = styled(Pulse).withConfig({
  displayName: "SkeletonHeading",
  componentId: "sc-kbc9pz-0"
})(["max-width:100%;height:40px;border-radius:5px;margin-bottom:24px;", " ", ""], function (props) {
  return props.h1 && css(["height:56px;margin-bottom:24px;"]);
}, function (props) {
  return props.h2 && css(["height:42px;margin-bottom:16px;"]);
});